import { useEffect } from "react";

/**
 * Closes a click-opened panel on a `pointerdown` outside `ref` or on Escape.
 *
 * The listeners are bound only while `open` is true.
 *
 * @param {{ current: HTMLElement | null }} ref Root that contains the trigger and the panel.
 * @param {boolean} open
 * @param {Function} close
 */
export default function useDismiss(ref, open, close) {
  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) close();
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") close();
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [ref, open, close]);
}
